import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CloseIcon, ErrorIcon } from '@/components/ui/Icons/Icons';
import { useOverlayClickHandler } from '@/hooks/useOverlayClickHandler';
import { useThemeMode } from '@/hooks/useThemeMode';

import * as S from './Statuses.styles';

export type ErrorModalProps = {
  onClose: () => void;
  onRetry?: () => void;
  title: string;
  description: string;
};

export const ErrorModal: FC<ErrorModalProps> = ({
  onClose,
  onRetry,
  title,
  description,
  ...rest
}) => {
  const { t } = useTranslation();

  const handleOverlayClick = useOverlayClickHandler(onClose);
  const isDark = useThemeMode('dark');

  return (
    <S.StatusModalOverlay onClick={handleOverlayClick} {...rest}>
      <S.StatusModalCard>
        <S.StatusIconWrapper $isStatus={false}>
          <ErrorIcon />
        </S.StatusIconWrapper>

        <S.ContentWrapper>
          <S.StatusModalTitle>{t(title)}</S.StatusModalTitle>
          <S.ModalExtraContentPaymentSubtitle>
            {t(description)}
          </S.ModalExtraContentPaymentSubtitle>
        </S.ContentWrapper>

        <S.StatusPrimaryButton onClick={onRetry}>
          <S.StatusPrimaryButtonLabel $isDark={isDark}>
            {t('Advertise.btn_try_again')}
          </S.StatusPrimaryButtonLabel>
        </S.StatusPrimaryButton>
        <S.StatusCloseButton onClick={onClose}>
          <CloseIcon />
        </S.StatusCloseButton>
      </S.StatusModalCard>
    </S.StatusModalOverlay>
  );
};
